__turbopack_context__.v({
  "navigationGradientBg": "Navigation-module-scss-module__v-QpQq__navigationGradientBg",
});
